<template>
  <v-autocomplete
    @input="setDealer"
    :value="dealer.id"
    ref="dealer_id"
    :items="dealers"
    item-text="name"
    item-value="id"
    :label="label || 'Select a Dealer'"
    :error-messages="errorMessages"
    :disable="disabled"
    return-object
    required
    :rules="rules"
    outlined
    prepend-inner-icon="mdi-car-side"
    :filter="dealerSearchFilter"
    hide-details="auto"
    dense
    menu-props="rounded"
  >
  </v-autocomplete>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'dealer-select',
  props: {
    dealer_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealers', 'dealer'])
  },
  watch: {
    dealer_id: {
      immediate: true,
      handler (newDealerId, oldDealerId) {
        if (!newDealerId) return null
        if (newDealerId === oldDealerId) return null
        this.$store.dispatch('DealerStore/getDealer', { id: newDealerId })
          .then(dealer => {
            this.setDealer(dealer)
          })
          .catch(error => {
            this.$logger.error('Error loading dealer into dealer-select', error.message)
            this.$flash({
              showClose: true,
              message: 'Error Loading Dealer(s). Reload to try again - DealerSelectWatch',
              type: 'error'
            })
          })
      }
    }
  },
  mounted: function () {
    this.$logger.trace('DealerStore - COMPONENT MOUNTED')
    return this.$store
      .dispatch('DealerStore/fetchDealers')
      .catch(error => {
        this.$logger.error('Error loading dealer(s) into dealer-select', error.message)
        // all dealers getting loaded from App - if can not load here, it will get loaded elsewhere
        // this was always popping up an error - keeping comment & old code in case it not working later
        // this.$flash({
        //   showClose: true,
        //   message: 'Error Loading Dealer(s). Reload to try again - DealerSelectMounted',
        //   type: 'error'
        // })
      })
  },

  methods: {
    ...mapMutations('DealerStore', ['saveDealer']),
    setDealer: function (selectedDealer) {
      this.saveDealer(selectedDealer)
      this.$emit('input', selectedDealer ? selectedDealer.id : null)
      this.$emit('update:dealer_id', selectedDealer ? selectedDealer.id : null)
    },
    dealerSearchFilter (item, queryText, itemText) {
      const dealerName = item.name.toLowerCase()
      const dmsKey = item.dms_key
      const searchText = queryText.toLowerCase()

      return dealerName.indexOf(searchText) > -1 || dmsKey.indexOf(searchText) > -1
    }
  }
}
</script>
